import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import About from './NestedRoute/About';
import ProjectMe from './NestedRoute/ProjectMe';
import Service from './NestedRoute/Service';
import Skill from './NestedRoute/Skill';
import Work from './NestedRoute/Work';
const Project = () => {
    const [page, setPage] = useState("About")
    const [pages, setPages] = useState("pages")
    const handleClick = (e) => {
        setPage(e)
        setPages("pages")
    }
    return (
        <section>
            <Container className='about-bg'>
                <div className="about-menu">
                    <ul className='ps-0'>
                        <li>
                            <button className={page=== "About" && pages}  onClick={()=> handleClick("About")} >About</button>
                        </li>
                        <li>
                            <button className={page=== "Skill" && pages }  onClick={()=> handleClick("Skill")} >Skill</button>
                        </li>
                        <li>
                            <button className={page=== "Project" && pages }  onClick={()=> handleClick("Project")} >Project</button>
                        </li>
                        <li>
                            <button className={page=== "Service" && pages }  onClick={()=> handleClick("Service")} >Service</button>
                        </li>
                        {/* <li>
                            <button className={page=== "Work" && pages }  onClick={()=> handleClick("Work")} >My Work</button>
                        </li> */}
                    </ul>
                </div>
                {page ==="About" && <About />}
                {page ==="Skill" && <Skill />}
                {page ==="Service" && <Service />}
                {page ==="Project" && <ProjectMe />}
                {page ==="Work" && <Work />}
            </Container>
        </section>
    );
};

export default Project;